import { twMerge } from "tailwind-merge"

export const ParagraphCustom = ({ children, className, size="medium" }) => {

    const mySize = {
        large:"lg:text-xl text-lg",
        medium:"lg:text-base text-sm",
        small:"lg:text-sm text-xs",
    }

    return (
        <p className={twMerge(`text-slate-700 ${mySize[size]}`, className)}>{children}</p>
    )
}